export const CLOUD_REGIONS = {
  azure: [
    "eastus", "eastus2", "centralus", "northcentralus", "southcentralus", "westcentralus", "westus", "westus2", "westus3",
    "canadacentral", "canadaeast", "brazilsouth",
    "northeurope", "westeurope", "francecentral", "francesouth", "germanywestcentral", "germanynorth",
    "norwayeast", "norwaywest", "swedencentral", "switzerlandnorth", "switzerlandwest", "polandcentral", "italynorth", "spaincentral",
    "uksouth", "ukwest",
    "uaenorth", "uaecentral", "qatarcentral", "israelcentral", "southafricanorth", "southafricawest",
    "eastasia", "southeastasia", "japaneast", "japanwest", "koreacentral", "koreasouth",
    "centralindia", "southindia", "westindia", "australiaeast", "australiasoutheast", "australiacentral",
  ],
  aws: [
    "us-east-1", "us-east-2", "us-west-1", "us-west-2", "ca-central-1", "ca-west-1", "sa-east-1",
    "eu-west-1", "eu-west-2", "eu-west-3", "eu-central-1", "eu-central-2", "eu-north-1", "eu-south-1", "eu-south-2",
    "me-south-1", "me-central-1", "il-central-1", "af-south-1",
    "ap-east-1", "ap-south-1", "ap-south-2", "ap-southeast-1", "ap-southeast-2", "ap-southeast-3", "ap-southeast-4",
    "ap-northeast-1", "ap-northeast-2", "ap-northeast-3",
  ],
  gcp: [
    "us-central1", "us-east1", "us-east4", "us-east5", "us-south1", "us-west1", "us-west2", "us-west3", "us-west4",
    "northamerica-northeast1", "northamerica-northeast2", "southamerica-east1", "southamerica-west1",
    "europe-west1", "europe-west2", "europe-west3", "europe-west4", "europe-west6", "europe-west8", "europe-west9", "europe-west10", "europe-west12",
    "europe-central2", "europe-north1", "europe-southwest1",
    "me-west1", "me-central1", "me-central2", "africa-south1",
    "asia-east1", "asia-east2", "asia-northeast1", "asia-northeast2", "asia-northeast3", "asia-south1", "asia-south2",
    "asia-southeast1", "asia-southeast2", "australia-southeast1", "australia-southeast2",
  ],
};
